import React, { useState } from 'react';
import Modal from '../common/Modal';
import { ShieldAlert, CheckCircle, XCircle } from 'lucide-react';

const EmployeeLimitModal = ({ request, isOpen, onClose, onApprove, onReject, loading }) => {
  const [newLimit, setNewLimit] = useState(request?.limitDetails?.requestedLimit || 50);
  const [note, setNote] = useState('');

  if (!isOpen || !request) return null;

  const { limitDetails, companyId } = request;

  const handleApproveSubmit = (e) => {
    e.preventDefault();
    onApprove(request._id, Number(newLimit), note);
  };

  const handleRejectSubmit = () => {
    onReject(request._id, note);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Review Limit Increase Request" maxWidth="max-w-lg">
      <div className="space-y-4">
        <div className="p-4 rounded-2xl bg-white/80 border border-slate-100">
          <div className="flex items-center space-x-2 text-green-700 font-bold text-sm mb-1">
            <ShieldAlert className="w-4 h-4" />
            <span>{companyId?.name || 'Company Tenant'}</span>
          </div>
          <p className="text-xs text-slate-600">
            Current Lock Limit: <strong className="text-slate-900">{limitDetails?.currentLimit}</strong>
          </p>
          <p className="text-xs text-slate-600">
            Requested Limit: <strong className="text-green-700">{limitDetails?.requestedLimit}</strong>
          </p>
          {limitDetails?.reason && (
            <p className="text-xs text-slate-500 italic mt-2">"{limitDetails?.reason}"</p>
          )}
        </div>

        <form onSubmit={handleApproveSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-slate-600 mb-1.5">Approved Employee Limit</label>
            <input
              type="number"
              min="1"
              required
              value={newLimit}
              onChange={(e) => setNewLimit(e.target.value)}
              className="w-full px-3.5 py-2 rounded-xl bg-white border border-slate-100 text-xs sm:text-sm text-slate-700 focus:outline-none focus:border-green-600 transition"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-600 mb-1.5">Resolution Note</label>
            <textarea
              rows="3"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Provide a note for the Company Admin..."
              className="w-full px-3.5 py-2 rounded-xl bg-white border border-slate-100 text-xs sm:text-sm text-slate-700 focus:outline-none focus:border-green-600 transition"
            />
          </div>

          <div className="flex items-center justify-between pt-4 border-t border-slate-100">
            <button
              type="button"
              onClick={handleRejectSubmit}
              disabled={loading}
              className="px-4 py-2 rounded-xl text-xs font-semibold text-rose-600 bg-rose-500/10 hover:bg-rose-500/20 border border-rose-500/20 flex items-center space-x-1 transition"
            >
              <XCircle className="w-4 h-4" />
              <span>Reject Request</span>
            </button>

            <div className="flex items-center space-x-2">
              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                className="px-4 py-2 rounded-xl text-xs font-medium bg-slate-100 text-slate-600 hover:bg-slate-200 transition"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-5 py-2 rounded-xl text-xs font-semibold text-slate-900 bg-emerald-600 hover:bg-emerald-500 shadow-lg shadow-emerald-600/30 flex items-center space-x-1 transition"
              >
                <CheckCircle className="w-4 h-4" />
                <span>Approve Request</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default EmployeeLimitModal;
